import { createContext } from 'react';

const TabContext = createContext(null);

export default TabContext;
